module.exports = __webpack_public_path__ + "media/images/front/icon_head_mypage-b8bc39aec275c535ed013c40e53b8bc9.png";